import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
type RequestsDTO = {
  requestIds: string[];
};
type AssignCourseResponse = {
  studentId: string;
  courseId: string;
  createdAt: string;
  updatedAt: string;
} & ApiError;
export const AcceptAllStudentRequest = (
  data: RequestsDTO
): Promise<AssignCourseResponse> => {
  return axios.patch(`/course/requests/acceptMany`, data);
};
